import React from "react";
import { AttrTypeName } from "src/types/AttrType";
import {
  FormObjectSection,
  FormObjectSectionsStore,
} from "src/components/Forms/FormObjectSection";
import { observer } from "mobx-react-lite";
import { DrawTab } from "./DrawTab";
import { ZSchedSettingsTask, ZSchedulingSettings } from "../../SchedulingTypes";
import { TaskTiesSection } from "./sections";
import { SchedulingObjType } from "../SchedulingSettingsStore";

interface PropsTaskFields {
  store: FormObjectSectionsStore<SchedulingObjType>;
}

const fieldName = (
  name: keyof ZSchedSettingsTask,
): ["taskSettings", keyof ZSchedSettingsTask] => ["taskSettings", name];

export const TaskFields: React.FC<PropsTaskFields> = observer(({ store }) => (
  <DrawTab>
    <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
      store={store}
      objKey={fieldName("templateObjectId")}
      objType="task"
      title="Объект: Задача"
      attrTitle="Выберите атрибуты:"
      attrs={[
        {
          attrKey: fieldName("nameAttributeId"),
          attrLabel: "Название",
          attrType: AttrTypeName.string,
        },
        {
          attrKey: fieldName("durationAttributeId"),
          attrLabel: "Длительность",
          attrType: AttrTypeName.int,
        },
        {
          attrKey: fieldName("performerLinkAttributeId"),
          attrLabel: "Исполнитель",
          attrType: AttrTypeName.object,
        },
        {
          attrKey: fieldName("priorityAttributeId"),
          attrLabel: "Приоритет",
          attrType: AttrTypeName.dictSingle,
        },
      ]}
    />
    <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
      store={store}
      objKey={fieldName("templateObjectId")}
      objType="task"
      isObjSelect={false}
      attrTitle="Выберите атрибуты принадлежности задачи:"
      attrs={[
        {
          attrKey: fieldName("groupAttributeId"),
          attrLabel: "К группе задач",
          attrType: AttrTypeName.object,
        },
        {
          attrKey: fieldName("planLinkAttributeId"),
          attrLabel: "К плану",
          attrType: AttrTypeName.object,
        },
        {
          attrKey: fieldName("relationLinkAttributeId"),
          attrLabel: "К привязкам задачи",
          attrType: AttrTypeName.childEntities,
        },
        {
          attrKey: fieldName("divisionLinkAttributeId"),
          attrLabel: "К подразделению",
          attrType: AttrTypeName.object,
        },
        {
          attrKey: fieldName("modelLinkAttributeId"),
          attrLabel: "К товарной позиции",
          attrType: AttrTypeName.object,
        },
        {
          attrKey: fieldName("supplierRelationAttributeId"),
          attrLabel: "К поставщику",
          attrType: AttrTypeName.object,
          required: false,
        },
      ]}
    />
    <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
      store={store}
      objKey={fieldName("templateObjectId")}
      objType="task"
      attrTitle="Выберите атрибуты сроков задачи:"
      isObjSelect={false}
      attrs={[
        {
          attrKey: fieldName("plannedStartDateAttributeId"),
          attrLabel: "Плановая дата начала",
          attrType: AttrTypeName.date,
        },
        {
          attrKey: fieldName("plannedEndDateAttributeId"),
          attrLabel: "Плановая дата окончания",
          attrType: AttrTypeName.date,
        },
        {
          attrKey: fieldName("settlementStartDateAttributeId"),
          attrLabel: "Расчетная дата начала",
          attrType: AttrTypeName.date,
        },
        {
          attrKey: fieldName("settlementEndDateAttributeId"),
          attrLabel: "Расчетная дата окончания",
          attrType: AttrTypeName.date,
        },
        {
          attrKey: fieldName("actualStartDateAttributeId"),
          attrLabel: "Фактическая дата начала",
          attrType: AttrTypeName.date,
        },
        {
          attrKey: fieldName("actualEndDateAttributeId"),
          attrLabel: "Фактическая дата окончания",
          attrType: AttrTypeName.date,
        },
      ]}
    />
    <TaskTiesSection
      objType="taskTies"
      tabKey="taskSettings"
      store={store}
      title="Объект: Привязки задач"
    />
    <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
      store={store}
      objKey={fieldName("supplierObjectId")}
      objType="supplier"
      title="Объект: Поставщик"
      required={false}
      attrs={[
        {
          attrKey: fieldName("supplierNameAttributeId"),
          attrLabel: "Атрибут названия",
          attrType: AttrTypeName.string,
          required: false,
        },
      ]}
    />
    <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
      store={store}
      objKey={fieldName("performerObjectId")}
      objType="performer"
      title="Объект: Исполнитель"
      attrs={[
        {
          attrKey: fieldName("performerLoadAttributeId"),
          attrLabel: "Загрузка исполнителя на задачу в день",
          attrType: AttrTypeName.int,
        },
      ]}
    />
  </DrawTab>
));
